// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/settings-row-button.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "boveda-vault-app")
// Destination      : packages/fleet/ui/src/settings-row-button.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo boveda-vault-app
//     node fleet/fleet.ts check --repo boveda-vault-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { Component } from "solid-js";
import { useNavigate } from "@tanstack/solid-router";
import { cn } from "@boveda/shared";

interface SettingsRowButtonProps {
  label: string;
  to: string;
  icon: Component<{ class?: string }>;
  class?: string;
}

export function SettingsRowButton(props: SettingsRowButtonProps) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      class={cn(
        "w-full flex items-center justify-between rounded-xl border border-accent/25 bg-muted/20 px-4 h-10 select-none cursor-pointer text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground",
        props.class,
      )}
      onClick={() => void navigate({ to: props.to })}
    >
      <div class="flex items-center gap-3">
        <props.icon class="h-4 w-4 text-muted-foreground" />
        <span>{props.label}</span>
      </div>
      <span class="text-muted-foreground text-xs">→</span>
    </button>
  );
}
